import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import styles from "../styles/addCustomEFModal.module.css";
import Selector from "../../../EmissionFactorManagement/components/Selector";
import eFManagementStore from "../../../Store/marco/emissionFactorManagementStore";
import { emissionFactorManagementAPI } from "../../../EmissionFactorManagement/API/emissionFactorManagementAPI";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
// 佐證資料 Modal
import AddCustomEFAttachModal from "./AddCustomEFAttachModal";
//翻譯
import { useTranslation } from "react-i18next";
import commonStore from "../../../Store/marco/commonStore";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import { addModalCatDropdownMap } from "../../services/addModalCatDropdownMap";
import { categoryDtoMap } from "../../services/categoryDtoMap";
import CustomEFSharingSettings from "../../../EmissionFactorManagement/components/CustomEFSharingSettings";
import { isCustomEFSharingValid } from "../../../EmissionFactorManagement/services/customEFSharing";
export const AddCustomEFModal = observer(() => {
  const store = emissionViewStore;
  const { _handleSwitchShowAddCustomEFModal } = emissionViewStore;
  const { companyList, orgList, scopeType } = commonStore;
  const [allComDropDown, setAllComDropDown] = useState([]);
  const [showCalorificValue, setShowCalorificValue] = useState(false);
  const { t } = useTranslation("ActivityMain");
  const cId = store.EAFormData?.selectedCom?.[0]?.companyId;

  // ===== 佐證資料 state =====
  const [showAttachModal, setShowAttachModal] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);  // 第一次上傳的 File 物件
  const [attachMode, setAttachMode] = useState(1);         // 1=多檔, 0=zip
  const [showSharingValidationError, setShowSharingValidationError] =
    useState(false);
  const hasFiles = attachedFiles.length > 0;
  const matchCIdName =
    allComDropDown && allComDropDown?.find((com) => com.value?.includes(cId));

  const defaultOptions = [
    { label: "CO₂", value: "CO₂" },
    { label: "CH₄", value: "CH₄" },
    { label: "N₂O", value: "N₂O" },
    { label: "HFCs", value: "HFCs" },
    { label: "PFCs", value: "PFCs" },
    { label: "SF₆", value: "SF₆" },
    { label: "NF₃", value: "NF₃" },
    { label: "CO₂e", value: "CO₂e" },
  ];

  const [options, setOptions] = useState([
    { label: "CO₂", value: "CO₂" },
    { label: "CH₄", value: "CH₄" },
    { label: "N₂O", value: "N₂O" },
    { label: "HFCs", value: "HFCs" },
    { label: "PFCs", value: "PFCs" },
    { label: "SF₆", value: "SF₆" },
    { label: "NF₃", value: "NF₃" },
    { label: "CO₂e", value: "CO₂e" },
  ]);

  ////////units
  const [modalUnits, setModalUnits] = useState([]);
  const getEFUnits = async () => {
    try {
      const data = await emissionFactorManagementAPI.getCustomUnitDropdown();
      console.log(data);
      setModalUnits(data);
    } catch (err) {
      console.error("Error fetching EF units", err);
      setModalUnits([]);
    }
  };

  useEffect(() => {
    getEFUnits();
  }, []);

  const filteredOptions = (firstGHG, secondGHG, thirdGHG) => {
    const excludedGases = ["HFCs", "PFCs", "SF₆", "NF₃", "CO₂e"];
    const basicGases = ["CO₂", "CH₄", "N₂O"];
    const selectedGHGs = [firstGHG, secondGHG, thirdGHG];

    ////如果選擇了特定的 排除其他選項
    const selectedExcludedGas = selectedGHGs.find((ghg) =>
      excludedGases.includes(ghg),
    );

    if (selectedExcludedGas) {
      return [];
    }

    ////如果選擇基本選項排除特定選項
    const shouldExcludeExtra = selectedGHGs.some((ghg) =>
      basicGases.includes(ghg),
    );

    return defaultOptions.filter((option) => {
      if (shouldExcludeExtra && excludedGases.includes(option.value)) {
        return false;
      }
      return !selectedGHGs.includes(option.value);
    });
  };

  ////////如果選了係數 剩下的option要過濾該系數
  useEffect(() => {
    let arr = filteredOptions(
      eFManagementStore.addCustomEFData?.firstGHG,
      eFManagementStore.addCustomEFData?.secondGHG,
      eFManagementStore.addCustomEFData?.thirdGHG,
    );
    setOptions([...arr, { label: t("Clear"), value: "" }]);
  }, [
    eFManagementStore.addCustomEFData?.firstGHG,
    eFManagementStore.addCustomEFData?.secondGHG,
    eFManagementStore.addCustomEFData?.thirdGHG,
  ]);

  ////////新增自定義
  const addCustomEF = async (data) => {
    const requestBody = data;
    if (cId) {
      requestBody.companyId = [cId];
    }
    requestBody.category = categoryDtoMap[store.selectedTab];

    try {
      await emissionFactorManagementAPI.addCustomEF(
        requestBody,
        store.standardId,
        attachedFiles,   // 佐證檔案
        attachMode,      // 模式 1=多檔, 2=zip
      );
    } catch (err) {
      console.error("Error Adding custom EF", err);
      throw err;
    }
  };

  useEffect(() => {
    ////////把orgList轉成{label,value} 原本是id
    let tempArr =
      scopeType === "AUTH"
        ? orgList
            .filter((item) => item.nodeStatus === "editable")
            .map((item) => ({ ...item, value: [item.value] }))
        : companyList
            .filter((item) => item.nodeStatus === "editable")
            .map((item) => ({
              ...item,
              orgType: "COMPANY",
              label: item.companyName,
              value: [item.id],
            }));

    ////////挑出orgType = COMPANY
    tempArr = tempArr.filter((item) => item.orgType === "COMPANY");

    setAllComDropDown(tempArr);
  }, [
    companyList,
    orgList,
    scopeType,
  ]);

  return (
    <div className={styles.bgc}>
      <div className={styles.container}>
        <div className={styles.title}>
          {t("Add Custom Emission Factor")}
          <span
            className={styles.close}
            onClick={() => {
              _handleSwitchShowAddCustomEFModal();
            }}
          >
            <CloseIcon />
          </span>
        </div>
        <div className={styles.main}>
          {/**Category */}
          <div className={styles.categoryWrap}>
            <Selector
              label={t("Category") + " :"}
              //options={modalCategory}
              options={addModalCatDropdownMap[store.standardId].map(
                (option) => ({
                  ...option,
                  label: t(option.label),
                }),
              )}
              dataKey={"category"}
              dataKeyName={"categoryName"}
              isDisabled={store.showAddCustomEFModal ? true : false}
              styles={styles}
              defaultValue={t(store.selectedTab) || ""}
            />
          </div>

          {/**select company */}
          <div className={styles.categoryWrap}>
            <Selector
              label={t("Select Company") + " :"}
              options={allComDropDown}
              dataKey={"companyId"}
              dataKeyName={"companyName"}
              isDisabled={store.showAddCustomEFModal && cId ? true : false}
              styles={styles}
              defaultValue={
                matchCIdName?.label
                  ? matchCIdName.label
                  : eFManagementStore.addCustomEFData.companyName
              }
            />
          </div>

          {/**Emission Factor Name */}
          <div className={styles.EFNameInputWrap}>
            <div className={styles.EFNameInputLabel}>
              <span style={{ color: "red" }}>* </span>
              {t("Emission Factor Name")}
            </div>

            <input
              className={styles.EFNameInput}
              onChange={(e) => {
                eFManagementStore._handleSetCustomEFData({
                  [`name`]: e.target.value || "",
                });
              }}
              value={eFManagementStore.addCustomEFData?.name || ""}
            />
          </div>

          {/**Reference Year */}
          <div className={styles.inputWrap}>
            <Selector
              label={t("Reference Year") + "："}
              options={[
                { label: "2025", value: "2025" },
                { label: "2024", value: "2024" },
                { label: "2023", value: "2023" },
                { label: "2022", value: "2022" },
                { label: "2021", value: "2021" },
                { label: "2020", value: "2020" },
                { label: "2019", value: "2019" },
                { label: "2018", value: "2018" },
                { label: "2017", value: "2017" },
              ]}
              dataKey={"year"}
              dataKeyName={"yearName"}
              styles={styles}
              defaultValue={eFManagementStore.addCustomEFData?.yearName || ""}
            />
          </div>

          {/**Base Unit */}
          <div className={styles.inputWrap}>
            <Selector
              label={t("Base Unit") + " :"}
              //options={modalUnits}
              options={modalUnits.map((option) => ({
                ...option,
                label: t(option.label),
              }))}
              dataKey={"unit"}
              dataKeyName={"unitName"}
              styles={styles}
              defaultValue={
                t(eFManagementStore.addCustomEFData?.unitName) || ""
              }
            />
          </div>

          {/**Emission Factor Unit */}
          <div className={styles.inputWrap}>
            <Selector
              label={t("Emission Factor Unit") + " :"}
              options={[
                { label: t("kg"), value: "3" },
                { label: t("tonne"), value: "4" },
                // { label: t("kgCO₂e"), value: "20" },
                // { label: t("tCO₂e"), value: "21" },
              ]}
              dataKey={"EFUnit"}
              dataKeyName={"EFUnitName"}
              styles={styles}
              defaultValue={
                t(eFManagementStore.addCustomEFData?.EFUnitName) || ""
              }
            />
          </div>

          {/*Description*/}
          <div className={styles.EFDecInputWrap}>
            <div className={styles.EFNameInputLabel}>
              <span style={{ color: "red" }}>* </span>
              {t("Emission Factor Description")}
            </div>

            <input
              className={styles.EFNameInput}
              onChange={(e) => {
                eFManagementStore._handleSetCustomEFData({
                  [`descEF`]: e.target.value || "",
                });
              }}
              value={eFManagementStore.addCustomEFData?.descEF || ""}
            />
          </div>

          {/* calorificValue toggle */}
          <label className={styles.biomassTitle}>
            {t("Show Calorific Value")}
          </label>

          <div className={styles.radioButtonWrap}>
            <label className={styles.radioButton}>
              <input
                type="radio"
                name="calorificValueToggle"
                value="yes"
                checked={showCalorificValue === true}
                onChange={() => {
                  setShowCalorificValue(true);
                  if (!eFManagementStore.addCustomEFData?.calorificValue) {
                    eFManagementStore._handleSetCustomEFData({
                      calorificValue: "",
                      calorificValueUnit:
                        eFManagementStore.addCustomEFData?.calorificValueUnit ||
                        "",
                      calorificValueSourceDesc:
                        eFManagementStore.addCustomEFData
                          ?.calorificValueSourceDesc || "",
                    });
                  }
                }}
              />{" "}
              {t("Yes")}
            </label>

            <label className={styles.radioButton}>
              <input
                type="radio"
                name="calorificValueToggle"
                value="no"
                checked={showCalorificValue === false}
                onChange={() => {
                  setShowCalorificValue(false);
                  eFManagementStore._handleSetCustomEFData({
                    calorificValue: null,
                    calorificValueUnit: "",
                    calorificValueSourceDesc: "",
                  });
                }}
              />{" "}
              {t("No")}
            </label>
          </div>

          {showCalorificValue && (
            <>
              {/* calorificValue */}
              <div className={styles.EFNameInputWrap}>
                <div className={styles.EFNameInputLabel}>
                  <span style={{ color: "red" }}>* </span>
                  {t("Calorific Value")}
                </div>

                <input
                  className={styles.EFNameInput}
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`calorificValue`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.calorificValue || ""
                  }
                  type="number"
                />
              </div>

              {/* calorificValueUnit */}
              <div className={styles.inputWrap}>
                <Selector
                  label={t("Calorific Value Unit") + " :"}
                  options={[
                    { label: t("kcal/kg"), value: "kcal/kg" },
                    { label: t("kcal/liter"), value: "kcal/liter" },
                    { label: t("kcal/cubic meter"), value: "kcal/cubic meter" },
                  ]}
                  dataKey={"calorificValueUnit"}
                  dataKeyName={"calorificValueUnitName"}
                  styles={styles}
                  defaultValue={
                    eFManagementStore.addCustomEFData?.calorificValueUnit || ""
                  }
                />
              </div>

              {/* calorificValueSourceDesc */}
              <div className={styles.EFNameInputWrap}>
                <div className={styles.EFNameInputLabel}>
                  <span style={{ color: "red" }}>* </span>
                  {t("Calorific Value Source Desc")}
                </div>

                <input
                  className={styles.EFNameInput}
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`calorificValueSourceDesc`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData
                      ?.calorificValueSourceDesc || ""
                  }
                />
              </div>
            </>
          )}

          {/**Biomass */}
          <label className={styles.biomassTitle}>
            <span style={{ color: "red" }}>* </span>
            {t("Biomass")}
          </label>

          <div className={styles.radioButtonWrap}>
            <label className={styles.radioButton}>
              <input
                onChange={(e) => {
                  eFManagementStore._handleSetCustomEFData({
                    [`biomass`]: e.target.value || "",
                  });
                }}
                type="radio"
                name="choice"
                value={true}
                checked={eFManagementStore.addCustomEFData?.biomass === "true"}
              />{" "}
              {t("Yes")}
            </label>

            <label className={styles.radioButton}>
              <input
                onChange={(e) => {
                  eFManagementStore._handleSetCustomEFData({
                    [`biomass`]: e.target.value || "",
                  });
                }}
                type="radio"
                name="choice"
                value={false}
                checked={eFManagementStore.addCustomEFData?.biomass === "false"}
              />{" "}
              {t("No")}
            </label>
          </div>

          <h4 className={styles.emissionFactorValueTitle}>
            {t("Emission Factor Value")}
          </h4>
          <div className={styles.titleWrap}>
            <div className={styles.smallTitle}>
              <span style={{ color: "red" }}>*</span>
              &#8202; {t("GHG")}
            </div>
            <div className={styles.smallTitle}>
              <span style={{ color: "red" }}>*</span>
              &#8202; {t("Factor Value")}
            </div>
            <div className={styles.smallTitle}>
              <span style={{ color: "red" }}>*</span>
              &#8202; {t("GWP")}
            </div>
            <div className={styles.smallTitle}>
              {t("Uncertainty ( Lower Limit )")}
            </div>
            <div className={styles.smallTitle}>
              {t("Uncertainty ( Upper Limit )")}
            </div>
          </div>

          {/**三個係數選項 */}
          <div className={styles.firstEF}>
            <div className={styles.selectorDiv}>
              {/**first GHG */}
              <Selector
                smallSelector={true}
                options={options}
                dataKey={"firstGHG"}
                dataKeyName={"firstGHGName"}
                styles={styles}
                width={"130px"}
                defaultValue={
                  eFManagementStore.addCustomEFData?.firstGHGName === t("Clear")
                    ? ""
                    : eFManagementStore.addCustomEFData?.firstGHGName || ""
                }
              />
            </div>

            {/**first Factor Value */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData.firstGHG &&
              eFManagementStore.addCustomEFData.firstGHG !== "" ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`firstFactorValue`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.firstFactorValue || ""
                  }
                  placeholder={0.0}
                />
              ) : (
                <></>
              )}
            </div>

            {/**first GWP */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.firstGHG === "HFCs" ||
              eFManagementStore.addCustomEFData?.firstGHG === "PFCs" ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore.addCustomEFData?.firstGHG === "HFCs"
                      ? eFManagementStore._handleSetCustomEFData({
                          [`HFCsGWP`]: e.target.value || "",
                        })
                      : eFManagementStore._handleSetCustomEFData({
                          [`PFCsGWP`]: e.target.value || "",
                        });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.firstGHG === "HFCs"
                      ? eFManagementStore.addCustomEFData?.HFCsGWP
                      : eFManagementStore.addCustomEFData?.firstGHG === "PFCs"
                        ? eFManagementStore.addCustomEFData?.PFCsGWP
                        : ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>

            {/**Uncertainly (Lower Limit) */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.firstGHG ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`firstUncertainlyLower`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData.firstUncertainlyLower ||
                    ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>

            {/**Uncertainly (Upper Limit) */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.firstGHG ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`firstUncertainlyUpper`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData.firstUncertainlyUpper ||
                    ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>
          </div>

          {/**second EF */}
          <div className={styles.secondEF}>
            <div className={styles.selectorDiv}>
              {/**second GHG */}
              <Selector
                smallSelector={true}
                options={options}
                dataKey={"secondGHG"}
                dataKeyName={"secondGHGName"}
                styles={styles}
                width={"130px"}
                defaultValue={
                  eFManagementStore.addCustomEFData?.secondGHGName ===
                  t("Clear")
                    ? ""
                    : eFManagementStore.addCustomEFData?.secondGHGName || ""
                }
              />
            </div>

            {/**second Factor Value */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData.secondGHG &&
              eFManagementStore.addCustomEFData.secondGHG !== "" ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`secondFactorValue`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.secondFactorValue || ""
                  }
                  placeholder={0.0}
                />
              ) : (
                <></>
              )}
            </div>

            {/**second GWP */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.secondGHG === "HFCs" ||
              eFManagementStore.addCustomEFData?.secondGHG === "PFCs" ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore.addCustomEFData?.secondGHG === "HFCs"
                      ? eFManagementStore._handleSetCustomEFData({
                          [`HFCsGWP`]: e.target.value || "",
                        })
                      : eFManagementStore._handleSetCustomEFData({
                          [`PFCsGWP`]: e.target.value || "",
                        });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.secondGHG === "HFCs"
                      ? eFManagementStore.addCustomEFData?.HFCsGWP
                      : eFManagementStore.addCustomEFData?.secondGHG === "PFCs"
                        ? eFManagementStore.addCustomEFData?.PFCsGWP
                        : ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>

            {/**Uncertainly (Lower Limit) */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.secondGHG ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`secondUncertainlyLower`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData.secondUncertainlyLower ||
                    ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>

            {/**Uncertainly (Upper Limit) */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.secondGHG ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`secondUncertainlyUpper`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData.secondUncertainlyUpper ||
                    ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>
          </div>

          {/**third EF */}
          <div className={styles.firstEF}>
            <div className={styles.selectorDiv}>
              {/**third GHG */}
              <Selector
                smallSelector={true}
                options={options}
                dataKey={"thirdGHG"}
                dataKeyName={"thirdGHGName"}
                styles={styles}
                width={"130px"}
                defaultValue={
                  eFManagementStore.addCustomEFData?.thirdGHGName === t("Clear")
                    ? ""
                    : eFManagementStore.addCustomEFData?.thirdGHGName || ""
                }
              />
            </div>

            {/**third Factor Value */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData.thirdGHG &&
              eFManagementStore.addCustomEFData.thirdGHG !== "" ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`thirdFactorValue`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.thirdFactorValue || ""
                  }
                  placeholder={0.0}
                />
              ) : (
                <></>
              )}
            </div>

            {/**third GWP */}
            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.thirdGHG === "HFCs" ||
              eFManagementStore.addCustomEFData?.thirdGHG === "PFCs" ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore.addCustomEFData?.thirdGHG === "HFCs"
                      ? eFManagementStore._handleSetCustomEFData({
                          [`HFCsGWP`]: e.target.value || "",
                        })
                      : eFManagementStore._handleSetCustomEFData({
                          [`PFCsGWP`]: e.target.value || "",
                        });
                  }}
                  value={
                    eFManagementStore.addCustomEFData?.thirdGHG === "HFCs"
                      ? eFManagementStore.addCustomEFData?.HFCsGWP
                      : eFManagementStore.addCustomEFData?.thirdGHG === "PFCs"
                        ? eFManagementStore.addCustomEFData?.PFCsGWP
                        : ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>

            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.thirdGHG ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`thirdUncertainlyLower`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData.thirdUncertainlyLower ||
                    ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>

            <div className={styles.selectorDiv}>
              {eFManagementStore.addCustomEFData?.thirdGHG ? (
                <input
                  type="number"
                  onChange={(e) => {
                    eFManagementStore._handleSetCustomEFData({
                      [`thirdUncertainlyUpper`]: e.target.value || "",
                    });
                  }}
                  value={
                    eFManagementStore.addCustomEFData.thirdUncertainlyUpper ||
                    ""
                  }
                  placeholder={0.0}
                />
              ) : (
                "-"
              )}
            </div>
          </div>

          <CustomEFSharingSettings
            value={eFManagementStore.addCustomEFData}
            showValidationError={showSharingValidationError}
            onChange={(sharing) => {
              eFManagementStore._handleSetCustomEFData(sharing);
              if (isCustomEFSharingValid(sharing)) {
                setShowSharingValidationError(false);
              }
            }}
          />
        </div>

        {/**footer */}
        <div className={styles.footer}>
          {/* Attach 按鈕 — 左下角 */}
          <div className={styles.attachLeft}>
            <button
              className={`${styles.attachBtn} ${hasFiles ? styles.attachBtnActive : ""}`}
              onClick={() => setShowAttachModal(true)}
              title={
                hasFiles
                  ? t("{{count}} file(s) attached", { count: attachedFiles.length })
                  : t("Attach supporting documents")
              }
              type="button"
            >
              <AttachFileIcon style={{ fontSize: 16, marginRight: 4 }} />
              {t("Attach")}
              {hasFiles && (
                <span className={styles.attachBadge}>{attachedFiles.length}</span>
              )}
            </button>
          </div>

          <div className={styles.footerActions}>
            <div
              className={styles.cancel}
              onClick={() => {
                _handleSwitchShowAddCustomEFModal();
                setAttachedFiles([]);
                setShowAttachModal(false);
              }}
            >
              {t("Cancel")}
            </div>
            <div
              className={styles.add}
              onClick={async () => {
                if (!isCustomEFSharingValid(eFManagementStore.addCustomEFData)) {
                  setShowSharingValidationError(true);
                  return;
                }
                try {
                  await addCustomEF(eFManagementStore.addCustomEFData);
                  _handleSwitchShowAddCustomEFModal();
                  eFManagementStore._handleClearCustomData();
                  setAttachedFiles([]);
                } catch (err) {
                  console.error(err);
                }
              }}
            >
              {t("Add")}
            </div>
          </div>
        </div>
      </div>

      {/* ===== 佐證資料獨立 Modal ===== */}
      <AddCustomEFAttachModal
        open={showAttachModal}
        onClose={() => setShowAttachModal(false)}
        onConfirm={(newFiles, newMode) => {
          setAttachedFiles(newFiles);
          setAttachMode(newMode);
        }}
        initialFiles={attachedFiles}
        initialMode={attachMode}
        efName={eFManagementStore.addCustomEFData?.name || ""}
      />
    </div>
  );
});

